import classNames from 'classnames'
import React from 'react'
import PlayButton from '@/components/Button/PlayButton'
import style from '../styles/media_detail.module.scss'
import Title from '@/components/Title'
import { useModal } from '@/hooks'

interface IProps {
  id: number
  video: any[] | null
  image: string | null
  title: string
  chunkLength: number
  playVideo: string
  setPlayVideo: any
}

const ImageOrVideo = ({
  id,
  video,
  image,
  title,
  chunkLength,
  playVideo,
  setPlayVideo
}: IProps): React.ReactElement => {
  const handlePlayVideo = (): void => {
    setPlayVideo(String(id))
  }

  const { openModal } = useModal()

  const handleOpenModal = (): void => {
    openModal('image', { image })
  }

  if (video === null || video === undefined || video.length === 0) {
    return (
      <img
        onClick={handleOpenModal}
        src={image ?? ''}
        alt='Фото'
        loading='lazy'
        className={classNames({
          [style.detail__block]: true,
          [style['detail__block--small']]: chunkLength <= 3,
          [style['detail__block--big']]: chunkLength > 3
        })}
      />
    )
  } else {
    return (
      <div
        className={classNames({
          [style.detail__block]: true,
          [style['detail__block--small']]: chunkLength <= 3,
          [style['detail__block--big']]: chunkLength > 3
        })}
      >
        {playVideo === String(id)
          ? (
            <video
              width='400px'
              height='300px'
              controls
              controlsList='nodownload'
              autoPlay
              className={style.detail__video}
            >
              <source src={video?.[0] ?? ''} type='video/mp4' />
            </video>
            )
          : (
            <>
              <img
                src={image ?? ''}
                alt='Фото'
                loading='lazy'
                className={style.detail__image}
              />
              <div className={style.detail__button_positioner}>
                <PlayButton onClick={handlePlayVideo} />
              </div>
              <Title type='h2' theme='h5' className={style.detail__video_title}>
                {title}
              </Title>
            </>
            )}
      </div>
    )
  }
}

export default ImageOrVideo
